import { Card } from "../parts/styled/Card";
import { SectionContainer, SectionTitle } from "../parts/main-page/ModernSection";
import Layout from "../parts/Layout";

export default function PolicyPage() {
    return (
        <Layout>
            <SectionContainer>
                <SectionTitle>
                    Polityka prywatności
                </SectionTitle>
                <Card.Container>
                    <Card.Body>
                        
                    </Card.Body>
                </Card.Container>
            </SectionContainer>
        </Layout>
    );
}